import React, { useState, useEffect } from "react";
import {
  Box,
  CardContent,
  Card,
  Link,
  Button,
  TextField,
  FormControl,
  Grid,
  FormHelperText,
  Container,
  MenuItem,
  InputLabel,
  Select,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import {
  getPaymentStatus,
  updatePaidStatus,
  getPrint,
  downloadExcel,
  getPaymentStatusWithPaging,
} from "./paymentAPIs";
import {
  API_DATE_FORMAT,
  BASIC_DATE_FORMAT,
  PAYMENT_CONSTANTS,
  PAYMENT_ROLES,
  PROD,
} from "../../common/constants";
import CustomDataGridToolbar from "../../common/customDataGridToolbar";
import { lastFiveDigitsComparator } from "../../common/commonFunction";
import { useNavigate, useLocation } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { VALIDATION } from "../../common/commonValidations";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Tabs, Tab, Stack } from "@mui/material";
import { Col } from "react-bootstrap";
import CustomDataGridToolbarServer from '../../common/customDataGridToolbarServer';
import { stakeholderType } from "../../common/spinLoader";
import { updatePaymentProcessStatus } from "./paymentAPIs";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon"
import moment from 'moment';
import dayjs from 'dayjs';
import { CloseIcon, SearchIcon } from "../../common/icons";

function PaymentStatusABRPLUser() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [excelDownloaded, setExcelDownloaded] = useState(false);
  const [paymentStatusDetails, setPaymentStatusDetails] = useState();
  const [selectedTab, setSelectedTab] = useState(state?.selectedTab ?? "All");
  const [details, setDetails] = useState({
    paymentDate: null,
    bankTransactionID: "",
    status: null,
    comment: ""
  });
  const [searchText, setSearchText] = useState("");
  const [sortField, setSortField] = useState("CreatedOn");
  const [sortOrder, setSortOrder] = useState("desc");
  const [page, setPage] = useState(0); // current page
  const [pageSize, setPageSize] = useState(10); // rows per page
  const [rowCount, setRowCount] = useState(0); // total rows from API
  const [stakeholderTab, setStakeholderTab] = useState(state?.stakeholderTab ?? "All");
  const [paymentTypeFilter, setPaymentTypeFilter] = useState(state?.paymentTypeFilter ?? "Invoice");
  const [status, setStatus] = React.useState("All");
  const [processedDates, setProcessedDates] = React.useState([]);
  const [selectedDates, setSelectedDates] = React.useState([]);
  const [searchFilter, setSearchFilter] = useState({
    "fromDate": null,
    "toDate": null,
  });

  let body = {
    loginId: localStorage.getItem("uuid"),
    userRole: localStorage.getItem("role"),
    urn: "",
    stakeholderType: stakeholderTab === "All" ? "All" : stakeholderTab,
    paymentType: paymentTypeFilter,
    status: "",
    pageNumber: page,
    pageSize: pageSize,
    sortColumn: sortField || "createdOn",
    sortDirection: sortOrder || "desc",
    filterText: searchText || "",
  };
  const [errorMessage, setErrorMessage] = useState({
    checkboxError: "",
    paymentDate: "",
    bankTransactionID: "",
  });
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setStatus(newValue);
    // setStakeholderTab("All");
    setPaymentTypeFilter("Invoice");
    setProcessedDates([]);
    setSelectedDates([]);
    if (newValue == "ReadyForPayment" || newValue == "Payment_Processed") {
      setPageSize(0);
      getPaymentStatusWithPaging("", stakeholderTab, newValue, "Invoice", 0, 0, sortField, setSortOrder, searchText, setPaymentStatusDetails, setRowCount, []);
    }
    else {
      setPageSize(10);
      getPaymentStatusWithPaging("", stakeholderTab, newValue, "Invoice", 0, pageSize, sortField, setSortOrder, searchText, setPaymentStatusDetails, setRowCount, []);
    }
  };
  const handleStakeholderTabChange = (e) => {
    setStakeholderTab(e.target.value);
    setPage(0);
    getPaymentStatusWithPaging("", e.target.value, status, paymentTypeFilter, 0, pageSize, sortField, setSortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
  };

  const onPaymentTypeChange = (e) => {
    setPaymentTypeFilter(e.target.value);
    setPage(0);
    getPaymentStatusWithPaging("", stakeholderTab, status, e.target.value, 0, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
  };

  const onStatusChange = (e) => {
    setStatus(e.target.value);
    getPaymentStatusWithPaging("", stakeholderTab, e.target.value, paymentTypeFilter, 0, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
  }
  const viewURNDetails = (urn) => {
    navigate("./viewPageWraper", { state: { urn: urn, goBack: true, status: status, selectedTab: selectedTab, stakeholderTab: stakeholderTab, pageName: "paymentStatus", paymentTypeFilter: paymentTypeFilter } });
  };

  const handleDateChange = (e) => {
    if (e.format("YYYY-MM-DD")) {
      setErrorMessage({ ...errorMessage, paymentDate: "" });
    }
    setDetails({ ...details, paymentDate: e.format("YYYY-MM-DD") });
  };

  const handleChange = (e) => {
    setDetails({
      ...details,
      [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value),
    });
  };

  const onClickPrint = () => {
    const referenceNoList = selectedRows.map((item) => item.referenceNumber);
    if (selectedRows.length === 0) {
      setErrorMessage({
        ...errorMessage,
        checkboxError: "Please select atleast one row",
      });
    } else if (selectedRows.length > 10) {
      toast.error("Maximum of 10 rows is only allowed to print");
    } else {
      getPrint(referenceNoList);
    }
  };
  const onDownload = () => {
    const referenceNoList = selectedRows.map((item) => item.referenceNumber);
    if (selectedRows.length === 0) {
      setErrorMessage({
        ...errorMessage,
        checkboxError: "Please select atleast one row",
      });
    } else {
      downloadExcel(referenceNoList, setExcelDownloaded);
    }
  };

  const onClickChangeToPaymentProcess = async () => {
    setDetails({ ...details, status: "Payment_Processed" });
    if (selectedRows?.length === 0) {
      setErrorMessage({
        ...errorMessage,
        checkboxError: "Please select atleast one row",

      });
    } else {
      setExcelDownloaded(false);
      setDialogOpen(true);
    }
  };

  const callbackStatusUpdate = () => {
    getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, 0, pageSize, sortField, setSortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
    setDetails({ paymentDate: null, bankTransactionID: "", comment: "" });
    setSelectedRows([]);
    setSelectedIds([]);
  }
  const onClickPaidStatus = () => {
    setDetails({ ...details, status: "Paid" });
    if (selectedRows?.length === 0) {
      setErrorMessage({
        ...errorMessage,
        checkboxError: "Please select atleast one row",
      });
    } else if (!details.paymentDate) {
      setErrorMessage({
        ...errorMessage,
        paymentDate: "Please enter payment date",
      });
    }
    else {
      setDialogOpen(true);
    }
  };
  function onConfirmSubmit() {
    setDialogOpen(false);
    const tempArr = selectedRows?.map((item) => ({
      paymentType: item?.paymentType,
      referenceNo: item?.referenceNumber,
      urn: item?.urn,
      paymentAmount: item?.totalAmount,
      stakeholderType: item?.stakeholderCategory,
    }));
    updatePaidStatus(
      tempArr,
      details,
      callbackStatusUpdate
    );
  }

  const handleClose = () => {
    setDialogOpen(false);
  };



  // function formatTimeFromDDMMYYYY_hhmmA(raw) {
  //   if (!raw || typeof raw !== 'string') return '';
  //   // Expect: "02-01-2025 01:15 PM"
  //   const parts = raw.trim().split(' ');
  //   if (parts.length < 3) return '';

  //   const [datePart, timePart, ampmRaw] = parts;
  //   const [ddStr, mmStr, yyyyStr] = datePart.split('-');
  //   const [hhStr, minStr] = timePart.split(':');

  //   const dd = Number(ddStr);
  //   const mm = Number(mmStr);
  //   const yyyy = Number(yyyyStr);
  //   const hh12 = Number(hhStr);
  //   const min = Number(minStr);
  //   const ampm = (ampmRaw || '').toUpperCase();

  //   if (
  //     !dd || !mm || !yyyy ||
  //     Number.isNaN(hh12) || Number.isNaN(min) ||
  //     (ampm !== 'AM' && ampm !== 'PM')
  //   ) {
  //     return '';
  //   }

  //   // Convert 12h -> 24h
  //   let hours = hh12 % 12;
  //   if (ampm === 'PM') hours += 12;

  //   const d = new Date(yyyy, mm - 1, dd, hours, min);
  //   if (Number.isNaN(d.getTime())) return '';

  //   // Example output: "01:15 PM" (localized)
  //   return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  // }
  const parseDate = (value) => {
    if (!value) return null;

    if (value instanceof Date) return value;

    // Handles ISO date
    const isoDate = new Date(value);
    if (!isNaN(isoDate.getTime())) return isoDate;

    // Handles DD/MM/YYYY or DD-MM-YYYY
    const parts = value.split(/[/-]/);

    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts;
      return new Date(
        Number(yyyy),
        Number(mm) - 1,
        Number(dd)
      );
    }

    return null;
  };

  const columns = [
    { field: "referenceNumber", headerName: "Reference Number", width: 150, display: "flex" },

    {
      field: "createdOnDt",
      headerName: "Invoice Date",
      width: 160,
      type: "date",
      valueGetter: (params) => parseDate(params.row.createdOnDt),
      valueFormatter: (params) =>
        params.value ? format(params.value, "dd/MM/yyyy") : "",
    },

    // {
    //   field: "createdOn", headerName: "Creation Time", width: 130, display: "flex",

    //   sortable: true,
    //   renderCell: (params) => {
    //     const raw = params?.row?.createdOn; // e.g., "02-01-2025 01:15 PM"
    //     return formatTimeFromDDMMYYYY_hhmmA(raw);
    //   },
    // },
    { field: "livNo", headerName: "Liv Number", width: 130, display: "flex" },
    {
      field: "urn",
      headerName: "URN",
      width: 150,
      sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      display: "flex",
      renderCell: (params) => {
        return (
          <Link
            to={params}
            onClick={() => {
              viewURNDetails(params?.row?.urn);
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "stakeholderName",
      headerName: "Stakeholder Name",
      width: 180,
      display: "flex"
    },
    {
      field: "stakeholderCategory",
      headerName: "Stakeholder Category",
      width: 200,
      display: "flex"
    },
    // { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 180 },
    { field: "paymentType", headerName: "Type of Payment", width: 150, display: "flex" },

    {
      field: "totalAmount",
      headerName: "Amount(INR)",
      width: 120,
      type: "number",
      valueGetter: (params) =>
        params.row.totalAmount ? Number(params.row.totalAmount) : 0,
      valueFormatter: (params) =>
        params.value ? Number(params.value).toFixed(2) : "0.00",
    },
    {
      field: "pitGrnSesNumber",
      headerName: "GRN Number",
      width: 120,
    },
    {
      field: "pitGrnSesDateStr",
      headerName: "GRN Date",
      width: 120,
      valueGetter: (params) => parseDate(params.row.createdOnDt),
      valueFormatter: (params) =>
        params.value ? format(params.value, "dd/MM/yyyy") : "",

    },

    {
      field: "paymentDateDt",
      headerName: "Payment Date (if Paid)",
      width: 150,
      type: "date",
      valueGetter: (params) => parseDate(params.row.paymentDateDt),
      valueFormatter: (params) =>
        params.value ? format(params.value, "dd/MM/yyyy") : "",
    },
    {
      field: "paymentProcessedDateDt",
      headerName: "Payment Processed Date",
      width: 180,
      type: "date",
      valueGetter: (params) => parseDate(params.row.paymentProcessedDateDt),
      valueFormatter: (params) =>
        params.value ? format(params.value, "dd/MM/yyyy") : "",
    },
    { field: "status", headerName: "Status", width: 200, display: "flex" },
    { field: "paymentId", headerName: "Status", width: 150, hide: true },
    {
      field: "bankTransactionID",
      headerName: "Bank Transaction Id",
      width: 150,
      display: "flex"
    },
    {
      field: "comment",
      headerName: "Comment",
      width: 250,
      display: "flex"
    },
  ];
  //  const fetchPaymentStatus = async () => {

  //   setLoading(true);

  //   try {

  //     const res = await getPaymentStatus(body);   // <- edit this API call

  //     setPaymentStatusDetails(res?.paymentStatus || []);

  //     setRowCount(res?.totalCount || 0);

  //   } catch (err) {

  //     console.error("API error", err);

  //   } finally {

  //     setLoading(false);

  //   }

  // };
  const handleDatePickerChange = (value) => {
    setProcessedDates(value);
    var arr = value?.map(item => (moment(item.toDate()).format(BASIC_DATE_FORMAT)));
    setSelectedDates(arr);
  }
  const handleSortModelChange = async (model) => {
    var sortColumn = "CreatedOn";
    switch (model[0]?.field) {
      case "urn":
        sortColumn = "Urn";
        break;
      case "referenceNumber":
        sortColumn = "ReferenceNumber";
        break;
      case "createdOn":
        sortColumn = "CreatedOn";
        break;
      case "livNo":
        sortColumn = "LivNo";
        break;
      case "stakeholderName":
        sortColumn = "StakeholderName";
        break;
      case "stakeholderCategory":
        sortColumn = "StakeholderCategory";
        break;
      case "paymentType":
        sortColumn = "PaymentType";
        break;
      case "totalAmount":
        sortColumn = "TotalAmount";
        break;
      case "paymentDate":
        sortColumn = "PaymentDate";
        break;
      case "status":
        sortColumn = "Status";
        break;
      case "bankTransactionID":
        sortColumn = "BankTransactionID";
        break;
      case "comment":
        sortColumn = "Comment";
        break;
      case "paymentProcessedDate":
        sortColumn = "PaymentProcessedDate";
        break;
      default:
        break;

    }
    setSortField(sortColumn);
    setSortOrder(model[0]?.sort);
    await getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, page, pageSize, sortColumn, model[0]?.sort, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
  };
  const fetchSearchData = async (searchInput) => {
    setSearchText(searchInput);
    await getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, page, pageSize, sortField, sortOrder, searchInput, setPaymentStatusDetails, setRowCount, selectedDates);
  };
  const fetchData = async () => {
    const res = await getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, 0, 0, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates); return res?.paymentStatus || [];
  }
  useEffect(() => {
    getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, page, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
  }, []);

  const handleFromToDateChange = (name, value) => {
    const formatted = value ? value.format("YYYY-MM-DD") : null;

    setSearchFilter((prev) => {
      if (
        name === "toDate" &&
        prev.fromDate &&
        dayjs(prev.fromDate).isAfter(value)
      ) {
        return {
          ...prev,
          toDate: formatted,
          fromDate: formatted
        };
      }

      return {
        ...prev,
        [name]: formatted
      };
    });
  };

  function searchDetails(e) {
    e.preventDefault();
    getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, 0, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates, searchFilter);
  }

  function clearSearch(e) {
    e.preventDefault();
    setSearchFilter({
      "fromDate": null,
      "toDate": null,
    });
    getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, 0, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates, null);
  }

  return (
    <Container maxWidth="xxl">
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY07</p>}
      <Typography variant="h4" gutterBottom>
        Payment Status
      </Typography>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={3}>
              <FormControl fullWidth >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="From Date"
                    value={searchFilter?.fromDate ? dayjs(searchFilter.fromDate) : null}
                    inputFormat="DD/MM/YYYY"
                    maxDate={
                      searchFilter?.toDate
                        ? dayjs(searchFilter.toDate)
                        : dayjs()
                    }
                    onChange={(value) => handleFromToDateChange("fromDate", value)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={3}>
              <FormControl fullWidth >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="To Date"
                    value={searchFilter?.toDate ? dayjs(searchFilter.toDate) : null}
                    inputFormat="DD/MM/YYYY"
                    maxDate={dayjs()}
                    onChange={(value) => handleFromToDateChange("toDate", value)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6} >
              <>
                <Button startIcon={<SearchIcon />} variant="contained" color="primary" onClick={(e) => searchDetails(e)} >
                  Search
                </Button>
                <Button startIcon={<CloseIcon />} sx={{ ml: 1 }} variant="outlined" color="primary" onClick={(e) => clearSearch(e)} >
                  Clear Search
                </Button>
              </>
            </Grid>
          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} lg={12}>
              <>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{ mb: 2 }}
                >
                  <Tab label="All Payment Requests" value="All" />
                  {localStorage.getItem("role") === PAYMENT_ROLES.FinanceUser && <Tab label="Ready for Payment" value="ReadyForPayment" />}
                  <Tab label="Payments Processed" value="Payment_Processed" />
                </Tabs>
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} spacing={1}>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="stakeholder-type-label">
                        Stakeholder Type
                      </InputLabel>
                      <Select
                        labelId="stakeholder-type-label"
                        id="stakeholder-type-select"
                        value={stakeholderTab}
                        onChange={(e) => handleStakeholderTabChange(e)}
                        label="Stakeholder Type"
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Grower">Grower</MenuItem>
                        <MenuItem value="LLE">LLE</MenuItem>
                        <MenuItem value="HIT">HIT</MenuItem>
                        <MenuItem value="Transporter">Transporter</MenuItem>
                        <MenuItem value="Interim Storage Operator">
                          Interim Storage Operator
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="payment-type-label">
                        Payment Type
                      </InputLabel>
                      <Select
                        labelId="payment-type-label"
                        id="payment-type-select"
                        value={paymentTypeFilter}
                        onChange={(e) => onPaymentTypeChange(e)}
                        label="Payment Type"
                      >
                        <MenuItem selected value="Invoice">Invoice</MenuItem>
                        <MenuItem value="Adv_Rlt">Advance/Royalty</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/*                                  {selectedTab === "All" && (*/}
                  {/*<Col xs={12} md={3}>*/}
                  {/*<FormControl fullWidth size="small">*/}
                  {/*<InputLabel id="status-label">Status</InputLabel>*/}
                  {/*<Select*/}
                  {/*       labelId="status-label"*/}
                  {/*       id="status-select"*/}
                  {/*       value={status}*/}
                  {/*       onChange={(e) => onStatusChange(e)}*/}
                  {/*       label="Status"*/}
                  {/*>*/}
                  {/*<MenuItem selected value="All">All</MenuItem>*/}
                  {/*<MenuItem value="ReadyForPayment">Ready for Payment</MenuItem>*/}
                  {/*</Select>*/}
                  {/*</FormControl>*/}
                  {/*</Col>*/}
                  {/*)}*/}
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small">
                      <DatePicker
                        value={processedDates}
                        onChange={handleDatePickerChange}
                        onClose={() => { getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, page, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates) }}
                        style={{ width: '100%', height: 40 }}
                        multiple
                        format="DD/MM/YYYY"
                        placeholder="Payment Processed Date"
                      />
                    </FormControl>
                  </Grid>
                </Stack>
                <Grid item xs={12} lg={12}>
                  <Box style={{ height: 450, width: "100%" }}>
                    {selectedTab == "All" && paymentStatusDetails && (
                      <DataGrid
                        //sx={{
                        //    "& .MuiDataGrid-cellContent": {
                        //        minHeight: 40,
                        //        maxHeight:80
                        //    },
                        //}}
                        rows={
                          paymentStatusDetails
                        }
                        /*  getRowHeight={() => 'auto'}*/
                        // rowCount={rowCount}
                        // rowsPerPageOptions={[10, 20, 50, 100]}
                        columns={columns}
                        // page={page}
                        // pageSize={pageSize}
                        // paginationMode="server"
                        // onPageChange={(newPage) => {
                        //   setPage(newPage);
                        //   getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, newPage, pageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
                        // }}
                        // onPageSizeChange={(newPageSize) => {
                        //   setPageSize(newPageSize);
                        //   getPaymentStatusWithPaging("", stakeholderTab, status, paymentTypeFilter, page, newPageSize, sortField, sortOrder, searchText, setPaymentStatusDetails, setRowCount, selectedDates);
                        // }}
                        // sortingMode="server"
                        onSortModelChange={handleSortModelChange}
                        getRowId={(row) => row.paymentId}
                        components={{
                          Toolbar: CustomDataGridToolbar,
                        }}
                        componentsProps={{
                          toolbar: {
                            rows: paymentStatusDetails,
                            columns: columns,
                            // onSearch: fetchSearchData, 
                            // onFetchData: fetchData, 
                            fileName: "Payment.xlsx",
                            name: "Export to Excel",
                            isExportToExcelRequired: true,
                            dateFields: ['createdOnDt', 'paymentDateDt', 'paymentProcessedDateDt']
                          }
                        }}
                      />)}
                    {(selectedTab == "ReadyForPayment" || selectedTab == "Payment_Processed") && paymentStatusDetails && (
                      <DataGrid
                        rows={
                          paymentStatusDetails
                        }
                        // rowCount={rowCount}
                        columns={columns}
                        // pageSize={10}
                        checkboxSelection
                        getRowId={(row) => row.paymentId}
                        selectionModel={selectedIds}
                        onSelectionModelChange={(ids) => {
                          const selectedIDs = new Set(ids);
                          const selectedRowData =
                            paymentStatusDetails?.filter((row) =>
                              selectedIDs.has(row.paymentId.toString())
                            );
                          setSelectedRows(selectedRowData);
                          setSelectedIds(ids);
                          setErrorMessage({
                            ...errorMessage,
                            checkboxError: "",
                          });
                        }}
                        isRowSelectable={(params) =>
                          selectedTab === "Payment_Processed" ? params.row.status === "Payment_Processed" :
                            (params.row.livNo &&
                              params.row.status ===
                              PAYMENT_CONSTANTS.paymentUnderProcess)
                        }
                        components={{
                          Toolbar: CustomDataGridToolbar,
                        }}
                        componentsProps={{
                          toolbar: {
                            rows: paymentStatusDetails,
                            columns: columns,
                            // onSearch: fetchSearchData, 
                            // onFetchData: fetchData, 
                            fileName: "Payment.xlsx",
                            name: "Export to Excel",
                            isExportToExcelRequired: true,
                            dateFields: ['createdOnDt', 'paymentDateDt', 'paymentProcessedDateDt']
                          }
                        }}
                      />)}
                  </Box>

                </Grid>

                <div className="error-msg" style={{ marginBottom: "3vh" }}>
                  {errorMessage.checkboxError}
                </div>
                {selectedTab === "ReadyForPayment" && localStorage.getItem("role") === PAYMENT_ROLES.FinanceUser && (
                  <Grid item xs={12} mt={2}>
                    <Box display="flex" justifyContent="flex-start" gap={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => onClickChangeToPaymentProcess(e)}
                        disabled={!excelDownloaded}

                      >
                        Change to Payment Processed Status
                      </Button>
                      <Button variant="contained" onClick={(e) => onDownload(e)}>

                        Download in Excel
                      </Button>
                      <Button variant="contained" onClick={onClickPrint}>

                        Print
                      </Button>
                    </Box>
                  </Grid>
                )}
              </>
            </Grid>
            {paymentStatusDetails &&

              (localStorage.getItem("role") === PAYMENT_ROLES.FinanceUser || localStorage.getItem("role") === PAYMENT_ROLES.Updater) &&

              selectedTab === "Payment_Processed" && (
                <>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Payment Date"
                          inputFormat="DD/MM/YYYY"
                          name="paymentDate"
                          value={details?.paymentDate}
                          onChange={(e) => {
                            handleDateChange(e);
                          }}
                          renderInput={(params) => (
                            <TextField fullWidth {...params} />
                          )}

                        />
                      </LocalizationProvider>
                      <FormHelperText sx={{ color: "red" }}>

                        {errorMessage.paymentDate}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField

                      fullWidth

                      label="Bank Transaction ID"

                      inputProps={{ maxLength: 50 }}

                      name="bankTransactionID"

                      value={details.bankTransactionID}

                      onChange={(e) => handleChange(e)}

                    />
                  </Grid>
                  <Grid item xs={12} lg={5}>
                    <TextField
                      sx={{ width: '100%', marginBottom: 2 }}
                      id="outlined-disabled"
                      label="Comments"
                      multiline
                      inputProps={{
                        maxLength: 500
                      }}
                      value={details?.comment}
                      onChange={(e) => setDetails({ ...details, comment: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={1} style={{ float: "right" }} >
                      <Button variant="contained" onClick={(e) => onClickPaidStatus(e)}>
                        Change Paid Status
                      </Button>
                    </Box>
                  </Grid>
                </>

              )}

          </Grid>
        </CardContent>
      </Card>
      <ConfirmationPopover
        onOpen={dialogOpen}
        onClose={handleClose}
        onConfirm={onConfirmSubmit}
        action="Submit"
      />
    </Container>
  );
}

export default PaymentStatusABRPLUser;
